import { Injectable } from '@angular/core';
import { EntityType } from '@app/shared/enums/entity-type.enum';
import { ApiService } from './api.service';

@Injectable()
export class SitiosService extends ApiService {
  entityType = EntityType.SITIO;
  url = 'api/sitios/';
}
